import Navbar from "../components/Navbar";
import AppNavBar from "../components/AppNavBar";
import { Grid, Stack } from "@mui/material";
import AppLeftSidebar from "../components/AppLeftSidebar";
import { Outlet } from "react-router-dom";

function Home() {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    // <div>
    //   <Navbar />
    //   <div className="home-container">
    //     {/* Left Sidebar */}
    //     <aside className="sidebar">
    //       <div className="profile-card">
    //         <div className="profile-header">
    //           <img
    //             src={user?.profilePicture || defaultAvatar}
    //             alt="Profile"
    //             className="profile-image"
    //           />
    //           <div>
    //             <h3>
    //               {user?.firstName || "Guest"} {user?.lastName || ""}
    //             </h3>
    //             <p>@{user?.username || "guest"}</p>
    //           </div>
    //         </div>
    //         <div className="profile-stats">
    //           <div className="stat-item">
    //             <div className="stat-value">1.3k</div>
    //             <div className="stat-label">Followers</div>
    //           </div>
    //           <div className="stat-item">
    //             <div className="stat-value">11k</div>
    //             <div className="stat-label">Following</div>
    //           </div>
    //           <div className="stat-item">
    //             <div className="stat-value">890</div>
    //             <div className="stat-label">Posts</div>
    //           </div>
    //         </div>
    //       </div>
    //       {/* Add more sidebar content */}
    //     </aside>

    //     {/* Main Content */}
    //     <main className="main-content">
    //       <div className="create-post">
    //         <div className="post-input">
    //           <img
    //             src={user?.profilePicture || defaultAvatar}
    //             alt="Profile"
    //             style={{
    //               width: "40px",
    //               height: "40px",
    //               borderRadius: "50%",
    //               objectFit: "cover",
    //             }}
    //           />
    //           <input
    //             type="text"
    //             placeholder="What's on your mind?"
    //             style={{ flex: 1, border: "none", outline: "none" }}
    //           />
    //         </div>
    //         <div className="post-actions">
    //           <button className="action-button">
    //             <svg width="24" height="24" viewBox="0 0 24 24">
    //               <path
    //                 fill="currentColor"
    //                 d="M21 6h-3.17L16 4h-6v2h5.12l1.83 2H21v12H3V8h5v2h2V4H5L3 6H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h19c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1zM8 13c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm5-3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3z"
    //               />
    //             </svg>
    //             Live Video
    //           </button>
    //           <button className="action-button">
    //             <svg width="24" height="24" viewBox="0 0 24 24">
    //               <path
    //                 fill="currentColor"
    //                 d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    //               />
    //             </svg>
    //             Photo/Video
    //           </button>
    //           <button className="action-button">
    //             <svg width="24" height="24" viewBox="0 0 24 24">
    //               <path
    //                 fill="currentColor"
    //                 d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    //               />
    //             </svg>
    //             Feeling Activity
    //           </button>
    //         </div>
    //       </div>
    //       {/* Add posts here */}
    //     </main>

    //     {/* Right Sidebar */}
    //     <aside className="right-sidebar">
    //       <div className="suggestions-section">
    //         <div className="section-header">
    //           <h3 className="section-title">Friend Suggestions</h3>
    //           <a href="#" className="see-all">
    //             See All
    //           </a>
    //         </div>
    //         {/* Friend suggestions */}
    //         <div className="suggestion-card">
    //           <img
    //             src={defaultAvatar}
    //             alt="User"
    //             style={{
    //               width: "40px",
    //               height: "40px",
    //               borderRadius: "50%",
    //               objectFit: "cover",
    //             }}
    //           />
    //           <div className="suggestion-info">
    //             <div className="suggestion-name">Julia Green</div>
    //             <div className="suggestion-meta">@juliagreen</div>
    //           </div>
    //           <button className="add-button">+</button>
    //         </div>
    //         {/* Add more suggestions */}
    //       </div>
    //     </aside>
    //   </div>
    // </div>

    <Grid container sx={{ bgcolor: "#f5f6f7" }}>
      <Grid
        item
        md={2.6}
        xl={2}
        sx={{
          "@media (min-width: 1536px)": {
            flexBasis: "16.666667% !important",
            flexGrow: 0,
            maxWidth: "16.666667% !important",
          },
          "@media (min-width: 1200px)": {
            flexBasis: "21.666667% !important",
            flexGrow: 0,
            maxWidth: "21.666667% !important",
          },
          "@media (min-width: 900px)": {
            flexBasis: "21.666667% !important",
            flexGrow: 0,
            maxWidth: "21.666667% !important",
          },
        }}
      >
        <AppLeftSidebar />
      </Grid>
      <Grid
        item
        md={9.4}
        xl={10}
        sx={{
          "@media (min-width: 1536px)": {
            flexBasis: "83.333333% !important",
            flexGrow: 0,
            maxWidth: "83.333333% !important",
          },
          "@media (min-width: 1200px)": {
            flexBasis: "78.333333% !important",
            flexGrow: 0,
            maxWidth: "78.333333% !important",
          },
          "@media (min-width: 900px)": {
            flexBasis: "78.333333% !important",
            flexGrow: 0,
            maxWidth: "78.333333% !important",
          },
        }}
      >
        {" "}
        <Stack direction="column">
          {" "}
          <AppNavBar />
          <Stack sx={{ my: "16px", mx: "14px" }}>
            <Outlet />
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default Home;

// <Stack sx={{ bgcolor: "#f5f6f7" }}>
// <AppNavBar />
// <Stack direction="row">
//   <AppLeftSidebar />
//   <Outlet />
// </Stack>
// </Stack>

{
  /* <Stack direction="row" sx={{ bgcolor: "#f5f6f7" }}>
<AppLeftSidebar />
<Stack direction="column">
  <AppNavBar />
  <Outlet />
</Stack>
</Stack> */
}
